import { fetchMarketResearch, FetchMarketResearchPayload } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const MarketResearchKeys = {
    all: ['marketresearch'] as const,
    lists: (payload?: FetchMarketResearchPayload) => [...MarketResearchKeys.all, 'list', payload] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...MarketResearchKeys.all, 'list', page, perPage, filters] as const,
    details: () => [...MarketResearchKeys.all, 'detail'] as const,
    detail: (params: string) => [...MarketResearchKeys.details(), params] as const,
}

export const useMarketResearchQuery = (
    payload?: FetchMarketResearchPayload,
    options?: { enabled?: boolean }
) => {
    return useQuery({
        queryFn: () => fetchMarketResearch(payload),
        queryKey: MarketResearchKeys.lists(payload),
        enabled: options?.enabled ?? true,
    })
}
